import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { ForbiddenRoot } from 'src/backoffice-app-code/routes/Routes';

export const LoginRedirectionListener = () => {
  const navigate = useNavigate();

  const navigateToLogin = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  const navigateToForbidden = useCallback(() => {
    navigate(ForbiddenRoot);
  }, [navigate]);

  useEffect(() => {
    window.addEventListener('REDIRECT_TO_LOGIN', navigateToLogin);

    return () => {
      window.removeEventListener('REDIRECT_TO_LOGIN', navigateToLogin);
    };
  }, [navigateToLogin]);

  useEffect(() => {
    window.addEventListener('REDIRECT_TO_FORBIDDEN', navigateToForbidden);

    return () => {
      window.removeEventListener('REDIRECT_TO_FORBIDDEN', navigateToForbidden);
    };
  }, [navigateToForbidden]);

  return <></>;
};
